import { render, staticRenderFns } from "./CampusGradeImport.vue?vue&type=template&id=e32954f0"
import script from "../../../controllers/custom/campus_grade/campus-grade-import.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/campus_grade/campus-grade-import.js?vue&type=script&lang=js&external"
import style0 from "./CampusGradeImport.vue?vue&type=style&index=0&id=e32954f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports